// extracted by mini-css-extract-plugin
export var action = "grants-module--action--ebef2";
export var actionDark = "grants-module--actionDark--907a0";
export var button = "grants-module--button--c353c";
export var grants = "grants-module--grants--0ebf8";
export var intro = "grants-module--intro--f74a8";